<template>
  <div>
    <b-button
      v-if="showButton"
      size="sm"
      @click="viewPurchaseApproverDetails()"
      variant="outline-info"
      >View Purchase Approvers</b-button
    >
    <b-modal
      id="purchase-approver-modal"
      ref="purchase-approver-modal"
      title="Purchase Approver Details"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      
      <div v-if="!isLoading && purchaseApproverList.length > 0">
        <b-card no-body class="mb-2" v-for="(approver, index) in purchaseApproverList" :key="index">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button 
              block 
              v-b-toggle="'accordion-' + index" 
              variant="primary"
              class="text-left"
              style="background-color: #36304a !important; border-color: #36304a !important; color: #ffffff !important;"
            >
                <div class="d-flex justify-content-between align-items-center w-100" style="color: #ffffff !important;">
                <div style="color: #ffffff !important;">
                  <b-badge :variant="approver.isActive == 1 ? 'success' : 'danger'" class="mr-2">
                    {{ approver.isActive == 1 ? "Active" : "Inactive" }}
                  </b-badge>
                  <strong style="color: #ffffff !important;">{{ approver.employeeName }}</strong>
                  <span class="ml-2" style="color: #ffffff !important;">(ID: {{ approver.userId }})</span>
                </div>
                <md-icon style="color: #ffffff !important;">expand_more</md-icon>
              </div>
            </b-button>
          </b-card-header>
          <b-collapse :id="'accordion-' + index" accordion="purchase-approver-accordion" role="tabpanel">
            <b-card-body>
              <!-- Basic Information Section -->
              <b-row class="mb-1">
                <b-col md="12">
                  <h6><strong style="color: #000000;">Basic Information</strong></h6>
                </b-col>
                <b-col md="6">
                  <div>
                    <strong style="color: #000000;">Purchase Approver Flag:</strong>
                    <b-badge :variant="approver.purchase_approver_flag == 'Yes' ? 'success' : 'secondary'" class="ml-2">
                      {{ approver.purchase_approver_flag || "No" }}
                    </b-badge>
                  </div>
                  <div>
                    <strong style="color: #000000;">Rights Require Validation:</strong>
                    <b-badge :variant="approver.ape_rights_require_validation ? 'warning' : 'info'" class="ml-2">
                      {{ approver.ape_rights_require_validation ? "Yes" : "No" }}
                    </b-badge>
                  </div>
                </b-col>
                <b-col md="6">
                  <div>
                    <strong style="color: #000000;">User View Page Preference:</strong>
                    <b-badge :variant="approver.user_view_page_pref ? 'success' : 'secondary'" class="ml-2">
                      {{ approver.user_view_page_pref ? "Yes" : "No" }}
                    </b-badge>
                  </div>
                </b-col>
              </b-row>

              <!-- Job Types Section -->
              <b-row class="mb-1" v-if="approver.ape_job_type && parseArray(approver.ape_job_type).length > 0">
                <b-col md="12">
                  <h6><strong style="color: #000000;">Job Types</strong></h6>
                  <div>
                    <b-badge
                      v-for="(jobType, idx) in parseArray(approver.ape_job_type)"
                      :key="idx"
                      variant="primary"
                      class="mr-2 mb-2 p-2"
                      style="font-size: 0.9rem;"
                    >
                      {{ jobType.text }}
                    </b-badge>
                  </div>
                </b-col>
              </b-row>

              <!-- Module Types Section -->
              <b-row class="mb-1" v-if="approver.ape_moduel_type && parseArray(approver.ape_moduel_type).length > 0">
                <b-col md="12">
                  <h6><strong style="color: #000000;">Module Types</strong></h6>
                  <div>
                    <b-badge
                      v-for="(moduleType, idx) in parseArray(approver.ape_moduel_type)"
                      :key="idx"
                      variant="info"
                      class="mr-2 mb-2 p-2"
                      style="font-size: 0.9rem;"
                    >
                      {{ moduleType.text }}
                    </b-badge>
                  </div>
                </b-col>
              </b-row>

              <!-- Shipment Types Section -->
              <b-row class="mb-1" v-if="approver.ape_shipment_type && parseArray(approver.ape_shipment_type).length > 0">
                <b-col md="12">
                  <h6><strong style="color: #000000;">Shipment Types</strong></h6>
                  <div>
                    <b-badge
                      v-for="(shipmentType, idx) in parseArray(approver.ape_shipment_type)"
                      :key="idx"
                      variant="success"
                      class="mr-2 mb-2 p-2"
                      style="font-size: 0.9rem;"
                    >
                      {{ shipmentType.text }}
                    </b-badge>
                  </div>
                </b-col>
              </b-row>

              <!-- Branch Information Section -->
              <b-row class="mb-1" v-if="approver.branch_relation">
                <b-col md="12">
                  <h6><strong style="color: #000000;">Branch Information</strong></h6>
                  <b-row>
                    <b-col md="4">
                      <div>
                        <strong style="color: #000000;">Branch Location:</strong><br/>
                        <span class="text-muted">{{ approver.branch_relation.mainLocation || "N/A" }}</span>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <div>
                        <strong style="color: #000000;">Branch Code:</strong><br/>
                        <span class="text-muted">{{ approver.branch_relation.BranchCode || "N/A" }}</span>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <div>
                        <strong style="color: #000000;">Pickup Location:</strong><br/>
                        <span class="text-muted">{{ approver.branch_relation.pickupLocation || "N/A" }}</span>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!-- Branch Validation Rights Section -->
              <b-row v-if="approver.branch_relation">
                <b-col md="12">
                  <div class="border rounded p-3">
                    <h6 class="mb-1"><strong style="color: #000000;">Branch Validation Rights</strong></h6>
                    <b-row>
                      <b-col md="3" class="mb-2">
                        <div class="border rounded p-2">
                          <strong style="color: #000000;">NOE Validation:</strong><br/>
                          <b-badge :variant="approver.branch_relation.is_noe_validation ? 'success' : 'secondary'" class="mt-1">
                            {{ approver.branch_relation.is_noe_validation ? "Yes" : "No" }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col md="3" class="mb-2">
                        <div class="border rounded p-2">
                          <strong style="color: #000000;">Expense Validation:</strong><br/>
                          <b-badge :variant="approver.branch_relation.is_expense_validation ? 'success' : 'secondary'" class="mt-1">
                            {{ approver.branch_relation.is_expense_validation ? "Yes" : "No" }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col md="3" class="mb-2">
                        <div class="border rounded p-2">
                          <strong style="color: #000000;">Additional Task Validation:</strong><br/>
                          <b-badge :variant="approver.branch_relation.is_additional_task_validation ? 'success' : 'secondary'" class="mt-1">
                            {{ approver.branch_relation.is_additional_task_validation ? "Yes" : "No" }}
                          </b-badge>
                        </div>
                      </b-col>
                      <b-col md="3" class="mb-2">
                        <div class="border rounded p-2">
                          <strong style="color: #000000;">S/Line Validation:</strong><br/>
                          <b-badge :variant="approver.branch_relation.is_sline_validation ? 'success' : 'secondary'" class="mt-1">
                            {{ approver.branch_relation.is_sline_validation ? "Yes" : "No" }}
                          </b-badge>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div v-if="!isLoading && purchaseApproverList.length === 0" class="text-center p-4">
        <p class="text-muted">No purchase approvers found.</p>
      </div>

      <b-button @click="hidePurchaseApproverDetails" variant="danger" class="mt-3 pull-right">
        Close
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import CustomLoader from "./customLoader.vue";
import SlineAccountServices from "../../services/SlineAccountServices.js";

export default {
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      purchaseApproverList: [],
    };
  },
  components: {
    CustomLoader,
  },
  methods: {
    parseArray(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      try {
        return typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        console.error("Error parsing array:", e);
        return [];
      }
    },
    viewPurchaseApproverDetails() {
      this.getPurchaseApproverList();
      this.$refs["purchase-approver-modal"].show();
    },
    hidePurchaseApproverDetails() {
      this.$refs["purchase-approver-modal"].hide();
    },
    async getPurchaseApproverList() {
      this.isLoading = true;
      this.purchaseApproverList = [];
      
      try {
        const payload = this.payload && typeof this.payload === 'object' ? this.payload : {};
        const response = await SlineAccountServices.getPurchaseAccessUsers(
          payload,
          {}
        );
        
        if (response && response.data) {
          const { status, data, result } = response.data;
          
          if (status && data && Array.isArray(data)) {
            this.purchaseApproverList = data;
          } else if (result && Array.isArray(result)) {
            // Parse stringified arrays in result
            this.purchaseApproverList = result.map((item) => {
              const parsed = Object.assign({}, item);
              if (item.ape_job_type && typeof item.ape_job_type === "string") {
                try {
                  parsed.ape_job_type = JSON.parse(item.ape_job_type);
                } catch (e) {
                  parsed.ape_job_type = [];
                }
              }
              if (item.ape_moduel_type && typeof item.ape_moduel_type === "string") {
                try {
                  parsed.ape_moduel_type = JSON.parse(item.ape_moduel_type);
                } catch (e) {
                  parsed.ape_moduel_type = [];
                }
              }
              if (item.ape_shipment_type && typeof item.ape_shipment_type === "string") {
                try {
                  parsed.ape_shipment_type = JSON.parse(item.ape_shipment_type);
                } catch (e) {
                  parsed.ape_shipment_type = [];
                }
              }
              return parsed;
            });
          }
        }
      } catch (error) {
        console.error("Error fetching purchase approver list:", error);
        this.purchaseApproverList = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// purchaseApproverDetails.vue?2b987611